<template>
  <layout-base :title="$t(title)">
    <template slot="content">
      <bk-choice
          :label="$t('STEP_ONE.I_AM')"
          :choices="genderChoices"
          :value="gender"
          name="genderChoices"
          @input="selectGender"
          class="bk-choice"
      />
      <bk-choice
          :label="$t('STEP_ONE.LOOKING_FOR')"
          :choices="searchGenderChoices"
          :value="searchGender"
          name="searchGenderChoices"
          @input="updateSearchGender"
      />

      <bk-age-select
          @change="updateSearchAgeRange"
          :value="[searchAgeRange.min, searchAgeRange.max]"
          :min="18"
          :max="99"
          :min-range="5"
      />

    </template>
    <template slot="buttons">
      <bk-button @click="navigate">{{ $t(buttonTitle) }}</bk-button>
    </template>

    <template slot="usp">
      <coupon-box v-if="!coupon.isEmpty()" />
      <premium-hint v-else-if="promoter === '115'"></premium-hint>
      <usp-box v-else />
    </template>
  </layout-base>
</template>

<script>
import UspBox from '../components/UspBox'
import LayoutBase from './LayoutBase'
import BkChoice from '../../../common/BkChoice'
import BkButton from '../../../common/BkButton'
import { mapMutations, mapState } from 'vuex'
import { stepOneGuard } from '../guards'
import BkAgeSelect from '../components/AgeSelect'
import CouponBox from '../components/CouponBox'
import PremiumHint from '../components/PremiumHint'

export default {
  beforeRouteEnter: stepOneGuard,
  components: { PremiumHint, BkChoice, LayoutBase, BkButton, BkAgeSelect, UspBox, CouponBox },
  methods: {
    selectGender(value) {
      if (value === 'w') this.updateSearchGender('m');
      else this.updateSearchGender('w');

      this.updateGender(value);
    },
    /**
     * Navigate to the next step
     */
    navigate () {
      this.$router.push('step-two')
      this.fireTrackEvent('Schritt1', 'Abgeschlossen')
    },
    ...mapMutations(['updateGender', 'updateSearchGender', 'updateSearchAgeRange']),
  },
  computed: {
    ...mapState(['gender', 'searchGender', 'searchAgeRange', 'showTitle', 'titleText', 'buttonText', 'coupon', 'promoter']),
    /**
     * create objects for the checkboxes with the translated text for the user gender
     * @returns {*[]}
     */
    genderChoices () {
      return [
        {
          id: 'male',
          text: this.$i18n.t('STEP_ONE.MAN'),
          value: 'm',
        },
        {
          id: 'female',
          text: this.$i18n.t('STEP_ONE.WOMAN'),
          value: 'w',
        },
      ]
    },
    title () {
      if (!this.showTitle) return ''

      return this.titleText.length > 0 ? this.titleText : 'STEP_ONE.TITLE'
    },
    buttonTitle () {
      return this.buttonText.length > 0 ? this.buttonText : 'GLOBAL.CONTINUE'
    },

    /**
     * create objects for the checkboxes with the translated text for the search gender
     * @returns {*[]}
     */
    searchGenderChoices () {
      return [
        {
          id: 'male',
          text: this.$i18n.t('STEP_ONE.SEARCH_MAN'),
          value: 'm',
        }, {
          id: 'female',
          text: this.$i18n.t('STEP_ONE.SEARCH_WOMAN'),
          value: 'w',
        },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
.mobile-reg-box > > > .mobile-reg-box__content {
  min-height: 320px;
}
</style>

